import script from "./DrawingCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawingCanvas.vue?vue&type=script&setup=true&lang=js"

import "./DrawingCanvas.vue?vue&type=style&index=0&id=586f798e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-586f798e"]])

export default __exports__